// ControlMaskedTextFactory.js

import $ from 'jquery';
import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import constants        from 'Constants.js';
import ControlModel    from 'ControlModel.js';
import MaskedTextControlView  from 'advanced-inputs/MaskedTextControlView.js';


//=============================================================================
//
// Creates a masked text input control, given a factoryService
// parameter key and a layout position. The factory key defines the
// control appearance through its template. It defines the initial rectangle
// of the control via a width and height from the factory parameter.
//
// Maty Rocha, January 11, 2016
//
//=============================================================================
class ControlMaskedTextFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.mask = '###-#######';
        attributes.textValue = '';
        attributes.encrypt = false;
        attributes.backgroundColor = '~inputBgColor';
        attributes.advancedBgGradientColor = '#FFFFFF';
        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.borderStyle= '~inputBorder';
        attributes.borderSize= '~inputBorder';
        attributes.cornerRadius= '~inputBorder';
        attributes.borderColor = '~inputBorderColor';
        attributes.styleBGColorText = '~inputBgColor';
        attributes.resizePadding = 12;
        attributes.translateProps = [
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

        const view = new MaskedTextControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlMaskedTextFactory = new ControlMaskedTextFactory();

export default controlMaskedTextFactory;